import { Heading as BundleTitle, Stack, RadioGroup, Inline, Checkbox, ValidationMessage } from '@etg/wings';
import { css } from '@eti/styles';
import { Pictogram } from '@eti/components';
import { useTranslation, useSiteContext, useValidation } from '@eti/providers';
import { Field as ReduxFormField } from 'redux-form';
import { getUniqFeatures } from '../../utils/utils';
import MobileOption from './MobileOption';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const pictogramAndTitleStyles = css`
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  margin-bottom: 24px;
`;
const discountPercentageTitleStyles = css`
  font-size: 1rem;
  margin-bottom: 16px;
`;
const RadioGroupComponent = _ref => {
  let {
    discountPercentageTitle,
    emptyOptionId,
    emptyOptionTitle,
    footerWrapperStyles,
    handleChange,
    handleModalOpen,
    input,
    meta,
    name,
    priceText,
    sellableOptions,
    shouldShowPricePerPerson,
    travelers
  } = _ref;
  const {
    brand: {
      code: brand
    }
  } = useSiteContext();
  const {
    t
  } = useTranslation();
  const uniqFeatures = getUniqFeatures(sellableOptions);
  const hasError = Boolean(meta.touched && meta.error) || Boolean(meta.touched && input.value === undefined);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(RadioGroup, {
      hasError: hasError,
      name: "value",
      onChange: handleChange,
      selectedValue: input.value,
      children: [/*#__PURE__*/_jsxs("div", {
        className: pictogramAndTitleStyles,
        children: [/*#__PURE__*/_jsx(Pictogram, {
          brand: brand,
          id: "ancillary-bundle",
          size: "32px"
        }), /*#__PURE__*/_jsx(BundleTitle, {
          level: 2,
          children: t('Product.FlexibleTicket.Bundle.Title')
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: discountPercentageTitleStyles,
        children: discountPercentageTitle
      }), /*#__PURE__*/_jsx(Stack, {
        spacing: 8,
        children: sellableOptions.map(option => /*#__PURE__*/_jsx(MobileOption, {
          handleModalOpen: handleModalOpen,
          numberOfTravelers: travelers.filter(traveler => traveler.ageType !== 'INF').length,
          option: option,
          priceText: priceText,
          shouldShowPricePerPerson: shouldShowPricePerPerson,
          uniqFeatures: uniqFeatures
        }, option.id))
      })]
    }), /*#__PURE__*/_jsxs(Inline, {
      align: "end",
      className: footerWrapperStyles,
      noWrap: true,
      children: [/*#__PURE__*/_jsx(Checkbox.Label, {
        htmlFor: `choice.${name}.${emptyOptionId}`,
        title: emptyOptionTitle,
        children: emptyOptionTitle
      }), /*#__PURE__*/_jsx(Checkbox, {
        checked: input.value === emptyOptionId,
        "data-testid": `productBundleItem-${emptyOptionId}`,
        id: `choice.${name}.${emptyOptionId}`,
        onChange: handleChange,
        value: emptyOptionId
      })]
    }), hasError && /*#__PURE__*/_jsx(ValidationMessage, {
      "data-testid": "purchasableBaggage-select-option-error-message",
      variant: "error",
      children: t('Validation.ProductSection.SelectOption')
    })]
  });
};
const hasBeenSelected = value => value !== null && value !== undefined;
const MobileBundle = _ref2 => {
  let {
    name,
    ...props
  } = _ref2;
  const validate = useValidation(name);
  const format = value => hasBeenSelected(value === null || value === void 0 ? void 0 : value.value) ? value === null || value === void 0 ? void 0 : value.value.id : undefined;
  return /*#__PURE__*/_jsx(ReduxFormField, {
    component: RadioGroupComponent,
    format: format,
    name: name,
    props: {
      ...props,
      name
    },
    validate: validate
  });
};
export default MobileBundle;